import type { StandardServicePageContent } from "~/content/servicePage";

export const HeatPumpInspectionContent: StandardServicePageContent = {
  heroTitle: "Przegląd pompy ciepła",
  quickFactsTitle: "Najważniejsze informacje w skrócie",
  quickFacts: [
    {
      label: "Jak często",
      value: "Zalecane co rok",
      description:
        "Roczny serwis pozwala sprawdzić urządzenie przed kolejnym sezonem grzewczym i utrzymać stabilną pracę całego układu. W wielu przypadkach jest też elementem warunków gwarancyjnych producenta.",
    },
    {
      label: "Ile kosztuje",
      value: "Najczęściej 400-900 zł w domu",
      description:
        "Cena zależy od typu pompy ciepła, zakresu serwisu, bufora, zasobnika c.w.u. i automatyki. Bardziej rozbudowane systemy albo układy z dodatkowymi obiegami wycenia się zwykle indywidualnie.",
    },
    {
      label: "Co obejmuje",
      value: "Parametry pracy, automatykę i ocenę całego układu",
      description:
        "Serwis obejmuje zwykle kontrolę jednostki, filtrów, połączeń hydraulicznych i elektrycznych oraz podstawowych nastaw. W praktyce ważna jest też współpraca z buforem, zasobnikiem i instalacją grzewczą.",
    },
    {
      label: "Kiedy działać wcześniej",
      value: "Przy alarmach, hałasie i wzroście zużycia energii",
      description:
        "Spadek komfortu cieplnego, częstsze odszranianie, błędy sterownika albo głośniejsza praca to sygnały, że pompa wymaga kontroli. Warto działać także po aktualizacji ustawień, remoncie instalacji lub przed końcem gwarancji.",
    },
  ],
  faqTitle: "Najczęstsze pytania o przegląd pompy ciepła",
  sections: [
    {
      title: "Na czym polega serwis pompy ciepła i co obejmuje",
      paragraphs: [
        `Przegląd pompy ciepła polega na ocenie, czy urządzenie pracuje stabilnie, bezpiecznie i z oczekiwaną sprawnością. Celem serwisu jest wychwycenie problemów, które mogą prowadzić do spadku wydajności, wzrostu zużycia energii albo awarii w sezonie grzewczym.`,
        `W praktyce sprawdza się podstawowe parametry pracy urządzenia, stan jednostki, filtrów, połączeń hydraulicznych i elektrycznych oraz automatykę sterującą. Ważne jest też to, czy pompa ciepła współpracuje prawidłowo z buforem, zasobnikiem i instalacją ogrzewania.`,
        `Po dobrze wykonanym serwisie właściciel powinien wiedzieć, czy urządzenie wymaga tylko standardowej obsługi, regulacji nastaw, czy może dalszej diagnostyki i naprawy. To szczególnie ważne tam, gdzie pompa ciepła jest głównym źródłem ogrzewania budynku.`,
      ],
    },
    {
      title: "Kiedy wykonywać przegląd pompy ciepła i dlaczego ma znaczenie dla gwarancji",
      paragraphs: [
        `Najczęściej zaleca się wykonywanie przeglądu pompy ciepła raz w roku. Taki rytm odpowiada praktyce producentów i pozwala przygotować urządzenie do kolejnego okresu intensywnej pracy, zanim spadek sprawności zacznie podnosić koszty ogrzewania.`,
        `W wielu przypadkach regularny serwis ma znaczenie dla utrzymania gwarancji. Brak potwierdzonego przeglądu może utrudnić późniejsze dochodzenie roszczeń, dlatego warto pilnować nie tylko terminu, ale też dokumentacji po wykonanej wizycie.`,
        `Dodatkowy serwis warto zlecić wcześniej, jeśli pojawiają się alarmy sterownika, niestabilna temperatura w budynku, hałas jednostki albo wyraźny wzrost poboru energii przy podobnym sposobie użytkowania domu.`,
      ],
    },
    {
      title: "Przegląd pompy ciepła w domu jednorodzinnym i typowe problemy",
      paragraphs: [
        `W domu jednorodzinnym pompa ciepła zwykle odpowiada za ogrzewanie i przygotowanie ciepłej wody, dlatego nawet drobne odchylenia szybko odbijają się na komforcie i rachunkach. To właśnie w takim układzie serwis daje właścicielowi największą kontrolę nad stanem urządzenia.`,
        `Najczęstsze problemy to spadek wydajności, głośniejsza praca, błędy sterownika, częste odszranianie, ograniczony przepływ lub nieprawidłowe nastawy automatyki. Część z nich wynika z prostych spraw eksploatacyjnych, ale część wymaga już dokładniejszej diagnostyki.`,
        `W praktyce dobrze przeprowadzony przegląd pozwala rozdzielić drobną regulację od sytuacji, w której potrzebna jest ingerencja serwisowa w konkretny element układu. Dzięki temu łatwiej zapobiec awarii w środku sezonu zimowego.`,
      ],
    },
    {
      title: "Cena przeglądu pompy ciepła",
      paragraphs: [
        `Cena przeglądu pompy ciepła w domu jednorodzinnym wynosi najczęściej około 400-900 zł. Rozpiętość bierze się z dużych różnic między prostymi instalacjami a systemami z buforem, zasobnikiem c.w.u., dodatkowymi obiegami i rozbudowaną automatyką.`,
        `Na wycenę wpływa również typ urządzenia, zakres serwisu, lokalny rynek i czas potrzebny na ocenę całej instalacji. W większych miastach oraz przy markach wymagających autoryzowanego serwisu ceny bywają wyższe.`,
        `Porównując oferty, warto sprawdzić, czy cena obejmuje tylko podstawowe oględziny, czy także regulację ustawień, wpis serwisowy i czytelną informację o stanie urządzenia. Przy pompie ciepła to właśnie jakość diagnozy ma zwykle największą wartość.`,
      ],
    },
  ],
  scopeTitle: "Zakres usług przeglądu pompy ciepła",
  scopeItems: [
    "Kontrola parametrów pracy",
    "Ocena jednostki zewnętrznej i wewnętrznej",
    "Sprawdzenie filtrów",
    "Kontrola połączeń hydraulicznych",
    "Kontrola połączeń elektrycznych",
    "Weryfikacja automatyki i sterownika",
    "Ocena współpracy z buforem i zasobnikiem",
    "Protokół serwisowy",
  ],
  seo: {
    title: "Przegląd pompy ciepła: cena, serwis, gwarancja, zakres",
    description:
      "Przegląd pompy ciepła dla domu jednorodzinnego. Sprawdź cenę serwisu, zakres kontroli, znaczenie dla gwarancji i kiedy zlecić przegląd wcześniej.",
  },
};
